import React from 'react'
import injectStyles from 'react-jss'

import Input from '@material-ui/core/Input'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import Checkbox from '@material-ui/core/Checkbox'
import { Chip, FormControlLabel } from '@material-ui/core'
import { useFormChildLogic } from '../index'
import { styles } from './styles'

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
  getContentAnchorEl: null,
  variant: 'menu',
}

const SelectMultiple = ({ classes, name, title, options, initValue = [] }) => {
  const { updateForm, value } = useFormChildLogic({
    name,
    initValue,
  })

  const handleChecked = (newValue, option) => {
    if (newValue) {
      updateForm([...value, option])
    } else {
      updateForm(value.filter(item => item.id !== option.id))
    }
  }

  const isChecked = (value, option) =>
    Boolean(value.find(item => item.id === option.id))

  return (
    <div className={classes.wrapper} style={{ width: '100%' }}>
      <FormControl className={classes.formControl}>
        <label className={classes.label}>{title}</label>
        <Select
          multiple
          value={value}
          input={<Input />}
          renderValue={selected => (
            <div className={classes.chips}>
              {selected.map(item => {
                return (
                  <Chip
                    key={item.id}
                    label={item.value}
                    className={classes.chip}
                  />
                )
              })}
            </div>
          )}
          MenuProps={MenuProps}
        >
          {options.map(option => (
            <MenuItem key={option.id} value={option} disableGutters={true}>
              <FormControlLabel
                className={classes.item}
                checked={isChecked(value, option)}
                onChange={(e, newValue) => handleChecked(newValue, option)}
                control={<Checkbox checked={isChecked(value, option)} />}
                label={option.value}
              />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  )
}

export default injectStyles(styles)(SelectMultiple)
